import { gql } from '@apollo/client';

export const UPSERT_INTERVENTION_INSTITUTION_MANAGER = gql`
  mutation UpsertInterventionInstitution($input: UpsertInterventionInstitutionInput!) {
    interventionInstitution: upsertInterventionInstitution(input: $input) {
      id
    }
  }
`;
